import { createAsyncThunk } from '@reduxjs/toolkit';
import { getIsPaidPortal } from '../services/is-paid-portal.service';
import { selectIsPaidPortalState } from '../selectors';
import { RequestStatus, isRequestFulfilled } from '../interface';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
import { DataFetchingError } from '../errors/DataFetchingError';
export const isPaidPortalThunk = createAsyncThunk('is-paid-portal', async (portalId, {
  getState,
  rejectWithValue
}) => {
  const state = getState();
  const {
    status,
    isPaidPortal: cachedIsPaidPortal
  } = selectIsPaidPortalState(state);

  // Return cached value if available
  if (isRequestFulfilled(status) && cachedIsPaidPortal !== null) {
    return {
      portalId,
      isPaidPortal: cachedIsPaidPortal
    };
  }
  if (!portalId) {
    // Skipping fetching iris app data if portalId is not provided (hubless)
    return {
      portalId,
      isPaidPortal: false
    };
  }
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  try {
    const isPaidPortal = await getIsPaidPortal(portalId);
    return {
      portalId,
      isPaidPortal
    };
  } catch (_error) {
    const requestError = _error;
    const error = new DataFetchingError('Failed to fetch paid portal status', {
      statusCode: requestError.status,
      cause: requestError
    });
    logger.error(error);
    return rejectWithValue({
      portalId,
      isPaidPortal: false
    });
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectIsPaidPortalState(state);
    return status === RequestStatus.IDLE;
  }
});